import React from 'react';
import { Stack, Typography } from '@mui/material';
import useEditBonusPhone from '../../../../../hooks/site/bonus/useEditBonusPhone';
import { useTranslation } from 'react-i18next';
import BotCurrencies from './BotCurrencies';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import SubgroupSave from '../../../../../components/bonus/ui/SubgroupSave';
import { ENUM_BONUS_ID } from '../../../../../enums/MenuItems';

export default function PhoneBot({ groupId, group }) {
  const { t } = useTranslation();
  const {
    startBotEnable,
    lockSetting,
    updateSubgroups,
    saveDisabled,
    currencies,
    changeFieldValues,
    changeEnable,
    changeSubgroup,
    changeLockSetting,
    onSave
  } = useEditBonusPhone(groupId);

  return (
    <Stack display={'flex'} flexDirection={'column'} gap={1} py={1}>
      <Stack display={'flex'} flexDirection={'row'} gap={2} justifyContent={'space-between'}>
        <CusCheckbox title="Enable" checked={startBotEnable} onChange={changeEnable} />
      </Stack>
      <Typography>
        {t('The bonus is given to the player who has given his phone number in Telegram.')}
      </Typography>
      <Stack gap={2}>
        <BotCurrencies
          currencies={currencies}
          groupId={groupId}
          changeFieldValues={changeFieldValues}
        />
      </Stack>

      <SubgroupSave
        lockSetting={lockSetting}
        updateSubgroups={updateSubgroups}
        saveDisabled={saveDisabled}
        id={ENUM_BONUS_ID.phone_bot}
        isNodeGroup={!group?.game}
        onSave={onSave}
        changeSubgroup={changeSubgroup}
        changeLockSetting={changeLockSetting}
      />
    </Stack>
  );
}
